/**
 * LETAHOST LUXE THEME - JAVASCRIPT
 */

(function() {
  'use strict';

  // Mobile Menu Toggle
  function initMobileMenu() {
    const mobileToggle = document.querySelector('.header__mobile-toggle');
    const mobileMenu = document.querySelector('.header__mobile-menu');
    const overlay = document.querySelector('.header__overlay');

    if (mobileToggle && mobileMenu && overlay) {
      // Fonction pour ouvrir le menu
      function openMenu() {
        mobileToggle.setAttribute('aria-expanded', 'true');
        mobileMenu.style.display = 'block';
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }

      // Fonction pour fermer le menu
      function closeMenu() {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.style.display = 'none';
        overlay.classList.remove('active');
        document.body.style.overflow = '';
      }

      // Toggle du menu au clic sur le bouton
      mobileToggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      // Fermer le menu au clic sur l'overlay
      overlay.addEventListener('click', function() {
        closeMenu();
      });
    }
  }

  // Product Image Gallery
  function initProductGallery() {
    const thumbnails = document.querySelectorAll('.product-template__thumbnail');
    const mainImage = document.getElementById('ProductMainImage');

    if (thumbnails.length && mainImage) {
      thumbnails.forEach(function(thumbnail) {
        thumbnail.addEventListener('click', function() {
          // Remove active class from all thumbnails
          thumbnails.forEach(t => t.classList.remove('active'));
          
          // Add active class to clicked thumbnail
          this.classList.add('active');
          
          // Update main image
          const newImageUrl = this.getAttribute('data-image-url');
          mainImage.src = newImageUrl;
        });
      });
    }
  }

  // Product Quantity Controls
  function initQuantityControls() {
    const minusButtons = document.querySelectorAll('[data-quantity-minus]');
    const plusButtons = document.querySelectorAll('[data-quantity-plus]');

    minusButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const input = this.parentElement.querySelector('input[type="number"]');
        const currentValue = parseInt(input.value);
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });
    });

    plusButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const input = this.parentElement.querySelector('input[type="number"]');
        const currentValue = parseInt(input.value);
        input.value = currentValue + 1;
      });
    });
  }

  // Add to Cart
  function initAddToCart() {
    const addToCartForm = document.getElementById('AddToCartForm');
    
    if (addToCartForm) {
      addToCartForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(this);
        const addButton = document.getElementById('AddToCart');
        const addButtonText = document.getElementById('AddToCartText');
        const originalText = addButtonText.textContent;
        
        // Disable button and show loading state
        addButton.disabled = true;
        addButtonText.textContent = 'Ajout en cours...';
        
        // Convertir FormData en JSON pour l'API Shopify
        const data = {
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity')) || 1
        };
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => {
              throw new Error(err.description || 'Erreur lors de l\'ajout au panier');
            });
          }
          return response.json();
        })
        .then(data => {
          // Update cart count
          updateCartCount();
          
          // Show success message
          addButtonText.textContent = 'Ajouté !';
          
          // Reset button after 2 seconds
          setTimeout(function() {
            addButton.disabled = false;
            addButtonText.textContent = originalText;
          }, 2000);
        })
        .catch(error => {
          console.error('Error:', error);
          addButton.disabled = false;
          addButtonText.textContent = originalText;
          alert(error.message || 'Une erreur est survenue. Veuillez réessayer.');
        });
      });
    }
  }

  // Update Cart Count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  // Product Quick Add (from product cards)
  function initQuickAdd() {
    const quickAddButtons = document.querySelectorAll('.product-card__quick-add');
    
    quickAddButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = this.getAttribute('data-variant-id') || this.getAttribute('data-product-id');
        const originalText = this.textContent;
        
        this.disabled = true;
        this.textContent = 'Ajout...';
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => {
              throw new Error(err.description || 'Erreur lors de l\'ajout au panier');
            });
          }
          return response.json();
        })
        .then(data => {
          updateCartCount();
          this.textContent = 'Ajouté !';
          
          setTimeout(() => {
            this.disabled = false;
            this.textContent = originalText;
          }, 2000);
        })
        .catch(error => {
          console.error('Error:', error);
          this.disabled = false;
          this.textContent = originalText;
          alert(error.message || 'Une erreur est survenue. Veuillez réessayer.');
        });
      });
    });
  }

  // Smooth Scroll for Anchor Links
  function initSmoothScroll() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href !== '#' && href !== '#MainContent') {
          e.preventDefault();
          const target = document.querySelector(href);
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  }

  // Sticky Header on Scroll
  function initStickyHeader() {
    const header = document.querySelector('.header');
    let lastScroll = 0;

    if (header) {
      window.addEventListener('scroll', function() {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll > 100) {
          header.classList.add('header--scrolled');
        } else {
          header.classList.remove('header--scrolled');
        }
        
        lastScroll = currentScroll;
      });
    }
  }

  // Initialize all functions when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initMobileMenu();
    initProductGallery();
    initQuantityControls();
    initAddToCart();
    initQuickAdd();
    initSmoothScroll();
    initStickyHeader();
    updateCartCount();
  });

  // Expose updateCartCount globally for other scripts
  window.updateCartCount = updateCartCount;

})();


